import React, { Component } from "react";

class SearchTranslationSection extends Component {
	render() {
		// Use either id or some other index name passed as prop
		const indexUsed = this.props.index ? this.props.index : "id";

		return (
			<React.Fragment>
				{this.props.items.length ? (
					<table className="display_table">
						<thead>
							<tr className="table-header">
								<th />
								<th>Title</th>
								<th>Last Edited</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{this.props.items.map((item, i) => (
								<tr
									className="clickable"
									key={i}
									onClick={() =>
										this.props.history.push(
											this.props.basePath + "/" + item[indexUsed]
										)
									}
								>
									<td className="record-number">
										{i + this.props.startPosition + 1}
									</td>
									<td data-id="Title">{item.title}</td>
									<td data-id="Date Edited">{item.date_edited}</td>
									<td className="edit-cell">
										<div className="edit_btn">Edit</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div>No Results</div>
				)}
			</React.Fragment>
		);
	}
}

SearchTranslationSection.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null
};

export default SearchTranslationSection;



// WEBPACK FOOTER //
// ./src/components/search/SearchTranslationSection.js